var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('z-modal',{attrs:{"show":_vm.show,"centered":"","size":"md","body-class":"p-0 rounded"},on:{"hide":_vm.hideModal}},[_c('form-create-client',{on:{"close":_vm.hideModal,"branch-created":_vm.handleBranchCreated}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }